import { COLORS, DEVICES, FONT_FAMILY } from '@Commons';
import styled from 'styled-components';

export const Wrapper = styled.div`
  background: ${COLORS.white};
  max-width: 450px;
  width: 100%;
  flex-direction: column;
  padding: 16px 16px 32px;
  border-radius: 4px;
  display: flex;
  justify-items: center;
  align-items: flex-start;

  .popular-countries-container__close-icon-container {
    width: 100%;
    .close-icon-container__close-icon {
      cursor: pointer;
      height: 24px;
      width: 24px;
      margin-left: auto;
      float: right;
    }
  }
  .container__heading {
    width: 100%;
    font-size: 18px;
    text-align: center;
    font-family: ${FONT_FAMILY.hellix.bold};
    line-height: 26px;
    color: ${COLORS.black};
    margin-bottom: 24px;
  }
`;
export const Box = styled.div`
  cursor: pointer;
  border: 1px solid ${COLORS.borderGrey};
  display: flex;
  flex-direction: column;
  padding: 16px;
  justify-content: space-between;
  align-items: flex-start;
  &:hover {
    background: ${COLORS.lightShadedGrey};
  }

  .grey-box {
    border: 1px solid ${COLORS.borderGrey};
    background: ${COLORS.borderGrey};
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    margin-top: 16px;
    padding: 4px 8px;
  }
  .transfer-limit-text {
    margin: 0 4px 0 8px;
    font-size: 12px;
    line-height: 18px;
  }
  .value {
    font-size: 12px;
    font-family: ${FONT_FAMILY.hellix.bold};
    line-height: 18px;
  }
  .text-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .inner-wrapper {
    display: flex;
    align-items: center;
  }

  .image-container {
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-right: 1px solid ${COLORS.borderGrey};
    padding: 0 6px 0 0;
    img {
      align-self: center;
      height: 24px;
      width: 24px;
    }
  }
  .mid-section-container {
    min-width: 326px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 0 12px;
    .main-text {
      display: flex;
      font-size: 16px;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 24px;
    }
    .sub-text {
      text-align: start;
      line-height: 22px;
      font-size: 14px;
      font-family: ${FONT_FAMILY.hellix.regular};
      color: ${COLORS.textGrey};
      text-align: left;
    }
    .faster-tag-box {
      border: 1px solid ${COLORS.borderGrey};
      background: ${COLORS.borderGrey};
      border-radius: 4px;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 4px 8px;
      margin-left: 8px;
    }
    .faster-tag {
      font-size: 10px;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 10px;
      margin-left: 4px;
    }
    @media ${DEVICES.mobileL} {
      min-width: unset;
    }
  }
  .verification-method-right-icon {
    text-align: center;
    display: flex;
    justify-content: flex-end;
    width: 24px;
    height: 24px;
  }
`;
export const BannerContainer = styled.div`
  display: flex;
  width: 450px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  position: relative;
  top: 11px;
  right: 4px;
  .triangle {
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 0 4px 4px 0;
    border-color: transparent ${COLORS.backgroudDarkPurple} transparent transparent;
    transform: rotate(0deg);
  }

  .new-payment-method-banner {
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0 2px 2px 0;
    background-color: ${COLORS.brandPurple};
    padding: 2px 4px;
    font-size: 10px;
    font-family: ${FONT_FAMILY.hellix.bold};
    color: ${COLORS.white};
  }
  @media ${DEVICES.mobileXL} {
    width: 90% !important;
  }
`;
